export default __webpack_public_path__ + "static/media/photo-tablet.e19d11b8.jpeg";